export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.pexels.com/photos/18136808/pexels-photo-18136808.jpeg" 
          alt="Professional auto body repair shop in Gardena"
          title="Ace's Auto Body Shop - Expert collision repair services"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <div className="space-y-8">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
            <i className="ri-shield-check-line text-amber-400"></i>
            <span className="text-sm text-white font-medium">Certified Technicians • Quality Parts • Fast Service</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-white font-['Space_Grotesk'] leading-tight">
            Reliable Auto Repair &<br />Performance Services
          </h1>

          <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto font-light">
            Expert Care for Your Vehicle — From Maintenance to Custom Upgrades
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <button 
              onClick={() => scrollToSection('contact')}
              className="px-8 py-4 bg-gradient-to-r from-amber-500 to-orange-600 text-white text-base font-semibold rounded-lg hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap"
            >
              Book a Service
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-base font-semibold rounded-lg border-2 border-white/30 hover:bg-white/20 transition-all whitespace-nowrap"
            >
              View Services
            </button>
          </div>

          <div className="grid grid-cols-3 gap-8 max-w-3xl mx-auto pt-12">
            <div className="text-center">
              <div className="text-4xl font-bold text-white font-['Space_Grotesk']">15+</div>
              <div className="text-sm text-gray-300 mt-1">Years Experience</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white font-['Space_Grotesk']">5000+</div>
              <div className="text-sm text-gray-300 mt-1">Cars Repaired</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white font-['Space_Grotesk']">98%</div>
              <div className="text-sm text-gray-300 mt-1">Satisfaction Rate</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button 
          onClick={() => scrollToSection('why-choose-us')}
          className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-white/20 transition-all cursor-pointer"
        >
          <i className="ri-arrow-down-line text-white text-xl"></i>
        </button>
      </div>
    </section>
  );
}
